__turbopack_context__.v({
  "rolloverItem": "RolloverItem-module__mB4SkG__rolloverItem",
});
